import { emperor } from '~/services';

export type ReasonCounts = Record<string, number>;

export interface DeliveryCounts {
  convertedSent: number;
  convertedDelivered: number;
  convertedRejected: number;
  convertedNoStatus: number;
  provisionedSent: number;
  provisionedDelivered: number;
  provisionedRejected: number;
  provisionedNoStatus: number;
}

export interface AuditPost extends DeliveryCounts {
  batchUuid: string;
  isBulk: boolean;
  isBackfilled: boolean;
  startedAt: string;
  endedAt: string | null;
  buildingCount: number;
  buildingNames: string[] | null;
  postUuid: string | null;
  postText: string | null;
}

export interface AuditListResponse {
  page: number;
  pageSize: number;
  total: number;
  posts: AuditPost[];
}

export interface AuditBuildingResult extends DeliveryCounts {
  building: string;
  buildingName: string | null;
  appUrl: string | null;
  startedAt: string;
  endedAt: string | null;
  rejectReasons: { converted?: ReasonCounts; provisioned?: ReasonCounts };
}

export interface AuditBatchResponse {
  batchUuid: string;
  isBulk: boolean;
  isBackfilled: boolean;
  postText: string | null;
  startedAt: string;
  endedAt: string | null;
  totals: DeliveryCounts;
  reasons: { converted: ReasonCounts; provisioned: ReasonCounts };
  buildings: AuditBuildingResult[];
}

export type AuditKind = 'all' | 'single' | 'bulk';

export const getNotificationAudit = async (params: {
  page: number;
  pageSize: number;
  kind: AuditKind;
}): Promise<{ data: AuditListResponse }> => {
  return await emperor.get('notification-audit', { params });
};

export const getNotificationAuditBatch = async (
  batchUuid: string
): Promise<{ data: AuditBatchResponse }> => {
  return await emperor.get(`notification-audit/${batchUuid}`);
};
